import {
  Info as Icon
} from 'components/icons';

export const meta = {
  id: 'DSCrudModules',
  title: 'DSCrudModules',
  allowIconOverwride: true,
  allowTitleOverwride: true,
  allowWindowOptionsOverwride: true,
  // category: 'xxx',
  exposes: [
    // {
    //   title: 'DSCrudModule',
    //   action: { module: 'DSCrudModules', props: { /* */ } },
    // },
    // {
    //   title: 'New DSCrudModule',
    //   action: { module: 'DSCrudModulesDetails', props: { context: 'add' } },
    // },
  ],
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `The CRUD module used to deal with DataStructures`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
